module.exports = __webpack_public_path__ + "img/dog3.c7a2de26.png";